import React, { useState } from 'react'
import { generalFilter, useDefaultColumn } from '../../../../util/filter';
import { Button, Grid, IconButton, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@material-ui/core';
import ScreenWidth from '../../../common/ScreenWidth';
import MuiTable from "@material-ui/core/Table";
import { useFilters, useGlobalFilter, useSortBy, useTable } from 'react-table';
import { Edit } from "@material-ui/icons";
import { ReportTeam } from './ReportTeam';
import { useHistory } from 'react-router-dom';

export const ReportTeamTable = ({ data }: any) => {

    const defaultColumn = useDefaultColumn();
    const theme = useTheme();
    const widthCurrent = ScreenWidth();
    const history = useHistory();

    


    const columns: any[] = React.useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filter: generalFilter,
            },
            {
                id: "Report Name",
                accessor: "report_name",
                filter: generalFilter,
                width: 350,
                minWidth: 280,
                maxWidth: 400,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },

            {
                id: "Writer Name",
                accessor: "writer_name",
                filter: generalFilter,
                width: 250,
                minWidth: 280,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Reviewer Name",
                accessor: "reviewer_name",
                filter: generalFilter,
                width: 250,
                minWidth: 280,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Verifier Name",
                accessor: "verifier_name",
                filter: generalFilter,
                width: 250,
                minWidth: 280,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Approver Name",
                accessor: "approver_name",
                filter: generalFilter,
                width: 250,
                minWidth: 280,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Duration",
                accessor: "duration",
                filter: generalFilter,
                width: 250,
                minWidth: 280,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Edit",
                Header: "Edit",
                disableFilters: true,
                disableSortBy: true,
                width: 100,
                align: "center",
                Cell: ({ row }: any) => {
                    const reportTeamId = row.original.id

                    return (
                        <IconButton
                            color='primary'
                            onClick={() => {
                                history.push(`report_team/${reportTeamId}`)

                            }}
                        >
                            <Edit fontSize="small" />
                        </IconButton>
                    )
                },
            },


        ],
        []
    );
    const { getTableProps, visibleColumns, headerGroups, rows, prepareRow } =
        useTable(
            {
                data: data,
                columns,
                defaultColumn,
                initialState: {
                    hiddenColumns: ["id"],

                },
            },
            useFilters,
            useGlobalFilter,
            useSortBy,

        );
    return (
        <>
           
            <TableContainer
                data-testid="tableContainer"
                style={{
                    ...theme.tableContainer,
                    maxHeight: "500px",
                    overflowX: 'auto',
                    overflowY: 'auto',
                    whiteSpace: 'nowrap',
                    maxWidth: `${widthCurrent}px`
                }}
                component={Paper}
            >
                <MuiTable stickyHeader {...getTableProps()} size="small">
                    <TableHead>
                        {headerGroups.map((headergroup) => (
                            <TableRow {...headergroup.getHeaderGroupProps()}>
                                {headergroup.headers.map((column) => (
                                    <TableCell
                                        style={{

                                            width: column.width,
                                            minWidth: column.minWidth,
                                            maxWidth: column.maxWidth,
                                            textAlign: 'center',
                                        }}

                                    >
                                        <Grid
                                            container
                                            direction="row"
                                            alignItems="center"
                                            spacing={0}
                                        >
                                            <Grid item xs={12} {...column.getHeaderProps()}>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={0}
                                                >
                                                    <Typography
                                                        variant="subtitle2"
                                                        style={{ textAlign: "center", width: "100%", verticalAlign: "middle" }}
                                                    >
                                                        {column.render("Header")}
                                                    </Typography>
                                                    {column.canFilter ? column.render("Filter") : null}



                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </TableCell>

                                ))}

                            </TableRow>
                        ))}
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            prepareRow(row);
                            return (

                                <>
                                    <TableRow {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                            return (
                                                <TableCell {...cell.getCellProps()}
                                                    style={{
                                                        width: cell.column.width,
                                                        minWidth: cell.column.minWidth,
                                                        maxWidth: cell.column.maxWidth,
                                                        lineHeight: "25px"
                                                    }}
                                                >
                                                    {cell.render("Cell")}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                </>
                            )
                        })

                        }
                    </TableBody>

                </MuiTable>

            </TableContainer>

            


        </>
    )
}


